<div class="content-padding">
    <div class="content-wrapper">
        <div class="content-header row">
            <div class="content-header-left col-md-12 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0 border-right">Billing Information</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <section>
                <div class="row">
                    <!-- left menu section -->
                    <div class="col-md-3 mb-2 mb-md-0">
                        <ul ngbNav #navVertical="ngbNav" class="nav nav-pills flex-column nav-left">
                            <!-- Update Payment Card -->
                            <li ngbNavItem>
                                <a ngbNavLink>
                                    <i data-feather="rotate-ccw" class="font-medium-3 mr-1"></i>
                                    <span class="font-weight-bold">Update Payment Card</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="col-12 col-sm-12 text-center mb-2">
                                                <h3>Update Payment Card</h3>
                                                <p>After Updating your old card would be removed by Stripe and updated one
                                                    would be
                                                    used</p>
                                                <!-- <p *ngIf='isCardAttached'>Your Current Card Number
                                                    is {{currentAttachedCardLast4Digits}}</p> -->
                                            </div>
                                            <div class="card standard-pricing popular text-center">
                                                <div class="card-body">
                                                    <form [formGroup]="cardForm" (ngSubmit)="updateCard()">
                                                        <div class="row">
                                                            <div class="col-12 col-sm-4">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control"
                                                                        mask="0000 0000 0000 0000 || 0000 000000 00000" autocomplete="off"
                                                                        formControlName="number"
                                                                        placeholder="Card Number" />
                                                                    <!-- <span class="text-danger"
                                                                        *ngIf="cf.number.touched && cf.number.errors.required">Card
                                                                        number
                                                                        required</span> -->
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-sm-3">
                                                                <div class="form-group">
                                                                    <input type="text" mask='00' class="form-control"
                                                                        formControlName="expMonth" autocomplete="off"
                                                                        placeholder='Month(MM)' />
                                                                    <!-- <span class="text-danger"
                                                                        *ngIf="cf.expMonth.touched && cf.expMonth.errors.required">Month
                                                                        required</span> -->
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-sm-3">
                                                                <div class="form-group">
                                                                    <input type="text" mask='0000' class="form-control"
                                                                        formControlName="expYear" autocomplete="off"
                                                                        placeholder="Year(YYYY)" />
                                                                    <!-- <span class="text-danger"
                                                                        *ngIf="cf.expYear.touched && cf.expYear.errors.required">Year
                                                                        required</span> -->
                                                                </div>
                                                            </div>
    
                                                            <div class="col-12 col-sm-2">
                                                                <div class="form-group">
                                                                    <input type="text" mask='000' class="form-control"
                                                                        formControlName="cvc" autocomplete="off"
                                                                        placeholder="Security Number" />
                                                                    <!-- <span class="text-danger"
                                                                        *ngIf="cf.cvc.touched && cf.cvc.errors.required">Security
                                                                        number required</span> -->
                                                                </div>
                                                            </div>
    
                                                            <div class="col-12">
                                                                <button id="submit" class="btn btn-block btn-primary" [disabled]="cardForm.invalid">
                                                                    <div class="spinner hidden" id="spinner"></div>
                                                                    <span id="button-text">Update Payment Card</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="alertMessage">
                                        <ngb-alert class="p-1" [dismissible]="true" [type]="'success'">{{ alertMessage }}</ngb-alert>
                                    </div>
                                </ng-template>
                            </li>
                            <!-- Cancel Subscription -->
                            <li ngbNavItem>
                                <a ngbNavLink>
                                    <i data-feather="scissors" class="font-medium-3 mr-1"></i>
                                    <span class="font-weight-bold">Cancel Subscription</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <div class="text-center mb-2">
                                        <h3>Cancel Subscription</h3>
                                        <span class="card-text">We are sorry to see you go.</span>
                                    </div>
                                    <div class="card standard-pricing popular text-center">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-12 col-sm-12">
                                                    <div class="validate-form">
                                                        <div class="form-group">
                                                            <textarea class="form-control" id="exampleFormControlTextarea1"
                                                                rows="6" [formControl]="reasonOfCanceling"
                                                                placeholder="Reason to Cancel"></textarea>
                                                            <span class="text-danger"
                                                                *ngIf='reasonOfCanceling.touched && reasonOfCanceling.invalid'>Please
                                                                give us the reason</span>
                                                        </div>
                                                    </div>
                                                    <button class="btn btn-block btn-primary mt-2"
                                                        [disabled]='reasonOfCanceling.invalid'
                                                        (click)='cancelSubscription()'>Cancel Subscription
                                                    </button>
                                                </div>
                                            </div>
    
                                            <div class="row">
                                                <div class="col-12 col-sm-12">
                                                    <ngb-alert [type]="'success'" *ngIf='cancelSubscriptionSuccess'>
                                                        <div class="alert-body">
                                                            <p>Subscription Canceled but you can use our free services
                                                                anytime</p>
                                                        </div>
                                                    </ngb-alert>
                                                    <ngb-alert [type]="'danger'" *ngIf='cancelSubscriptionError'>
                                                        <div class="alert-body">
                                                            <p>Error occurred while canceling the subscription try again</p>
                                                        </div>
                                                    </ngb-alert>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="alertMessage">
                                        <ngb-alert class="p-1" [dismissible]="false" [type]="'success'">{{ alertMessage }}</ngb-alert>
                                    </div>
                                </ng-template>
                            </li>
                            <!-- Past Invoices -->
                            <li ngbNavItem>
                                <a ngbNavLink>
                                    <i data-feather="file-text" class="font-medium-3 mr-1"></i>
                                    <span class="font-weight-bold">Past Invoices</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <div class="row">
                                        <div class="col-12 col-sm-12 text-center mb-2">
                                          <h3>Invoices</h3>
                                        </div>
                                      </div>
                                       <div class="card standard-pricing popular">
                                        <div class="card-body">      
                                          <div class="row">
                                            <div class="col-12">
                                              <div class="table-responsive">
                                                <table class="table table-hover">
                                                  <thead>
                                                  <tr>
                                                    <th>Invoice ID</th>
                                                    <th>Date</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                    <th>Download</th>
                                                  </tr>
                                                  </thead>
                                                  <tbody *ngIf='invoices?.length > 0 && !loading'>
                                                  <tr
                                                    *ngFor='let invoice of invoices | paginate: { itemsPerPage: 15, currentPage: pageNumber }'>
                                                    <td>
                                                      <span class="font-weight-bold">{{invoice.id}}</span>
                                                    </td>
                                                    <td>
                                                      <span class="font-weight-bold">{{(invoice.created * 1000) | date:'medium'}}</span>
                                                    </td>
                                                    <td>
                                                      <span class="font-weight-bold">${{invoice.amount_paid / 100}}</span>
                                                    </td>
                                                    <td>
                                                      <span class="badge badge-pill badge-light-success mr-1"
                                                            *ngIf="invoice.status == 'paid' ">Paid</span>
                                                    </td>
                                                    <td>
                                                      <button type="button" class="btn btn-sm" (click)='downloadPdf(invoice.invoice_pdf)'>
                                                        <i data-feather='download'></i>
                                                      </button>
                                                    </td>
                                                  </tr>
                                                  </tbody>
                                                  <tfoot>
                                                        <pagination-controls (pageChange)="pageNumber = $event" *ngIf='invoices?.length > 0'></pagination-controls>
                                                      <span class="text-center" *ngIf='invoices?.length < 1 && !loading'><b>No Invoices of you yet</b></span>
                                                  </tfoot>
                                                </table>
                                                <div class="text-center">
                                                    <div class="spinner-border" role="status" *ngIf="loading"></div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                </ng-template>
                            </li>
                            <!-- Payment FAQ -->
                            <li ngbNavItem>
                                <a ngbNavLink>
                                    <i data-feather="help-circle" class="font-medium-3 mr-1"></i>
                                    <span class="font-weight-bold">Payment FAQ</span>
                                </a>
                                <ng-template ngbNavContent>
                                    <div class="pricing-faq">
                                        <h3 class="text-center">FAQ's</h3>
                                        <p class="text-center">Let us help answer the most common questions.</p>
                                        <div class="accordion collapse-margin mt-2">
                                            <ngb-accordion [destroyOnHide]="false" [closeOthers]="true" #acc="ngbAccordion">
                                                <ngb-panel [cardClass]="'collapse-margin'">
                                                  <ng-template ngbPanelTitle>
                                                    <span>Does my subscription automatically renew?</span>
                                                  </ng-template>
                                                  <ng-template ngbPanelContent>
                                                    Yes.
                                                  </ng-template>
                                                </ngb-panel>
                                                <ngb-panel [cardClass]="'collapse-margin'">
                                                    <ng-template ngbPanelTitle>
                                                      <span>Can I store the item on an intranet so everyone has access?</span>
                                                    </ng-template>
                                                    <ng-template ngbPanelContent>
                                                        No. We do not allow sharing of accounts. Your accounts a monitored through IP address. Only One allowed at a time.
                                                    </ng-template>
                                                </ngb-panel>
                                                <ngb-panel [cardClass]="'collapse-margin'">
                                                    <ng-template ngbPanelTitle>
                                                      <span>Can I cancel anytime?</span>
                                                    </ng-template>
                                                    <ng-template ngbPanelContent>
                                                        Yes. However, we do not pro-rate your payments. Once paid, you are locked in for the duration of your payment.
                                                    </ng-template>
                                                </ngb-panel>
                                            </ngb-accordion>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                        </ul>
                    </div>
                    <!--/ left menu section -->
                    <!-- right content section -->
                    <div class="col-md-9">
                        <div [ngbNavOutlet]="navVertical" class="p-0 col-12"></div>
                    </div>
                </div>
                <!--/ right content section -->
            </section>
        </div>
    </div>
    <app-toast-container2 aria-live="polite" aria-atomic="true"></app-toast-container2>
</div>